module.exports = __webpack_public_path__ + "static/media/wiifittrainer_0.3d2ae207.png";